export class ResendCodeRequest {
  email: string;
}
